<template functional>
  <div class="mtx-sidenav">
    <header class="text-center mb-5">
      <h3 class="mb-1">Matryx</h3>
      <p>
        Secure Platform for tracking Intellectual Property and Crowdsourcing Science
      </p>
      <!-- <ZeroExInstant /> -->
      <component :is="$options.components.ZeroExInstant" />
    </header>

    <nav class="mtx-sidenav__main">
      <ul class="list-plain">
        <li v-for="link in $options.navLinks" :key="link.to || link.href" class="mb-2">
          <RouterLink
            v-if="link.to"
            :to="link.to"
            @click.native="showSidebar = false"
            v-html="link.text"
          ></RouterLink>
          <a v-else-if="link.href" :href="link.href" :target="link.target">{{ link.text }}</a>
        </li>
      </ul>
    </nav>

    <ul class="mtx-sidenav__social list-plain">
      <li>
        <a
          href="https://www.facebook.com/matryxai/"
          target="_blank"
          aria-label="Like us on Facebook"
        >
          <MtxSvg icon="icon-facebook" />
        </a>
      </li>
      <li>
        <a href="https://twitter.com/matryx_ai" target="_blank" aria-label="Follow us on Twitter">
          <MtxSvg icon="icon-twitter" />
        </a>
      </li>
      <li>
        <a href="https://t.me/matryxai" target="_blank" aria-label="Join us on Telegram">
          <MtxSvg icon="icon-telegram" />
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import ZeroExInstant from "@/components/misc/ZeroExInstant"

const NETWORK_ID = process.env.VUE_APP_NETWORK_ID || "3"
const navLinks = [
  {
    text: "Tournaments",
    to: "/tournaments"
  },
  {
    text: "Create a Tournament",
    to: "/tournaments/create"
  },
  {
    text: "<div>First To Hash</div><small class='ml-1'><i>- Timestamp on Blockchain</i></small>",
    to: "/first-to-hash"
  },
  {
    text: "About & FAQ",
    to: "/about"
  },
  {
    text: "Token Info",
    to: "/token"
  },
  {
    text: "Blog",
    href: "https://blog.matryx.ai",
    target: "_blank"
  }
]

if (NETWORK_ID !== "1") {
  navLinks.splice(3, 0, {
    text: "Get Testnet ETH & MTX",
    to: "/faucet"
  })
}

export default {
  components: {
    ZeroExInstant
  },

  navLinks
}
</script>

<style lang="scss">
.mtx-sidenav {
  display: flex;
  min-height: 100%;
  flex-direction: column;

  &__main {
    flex-grow: 1;

    li > a {
      display: block;
      font-weight: bold;
      transition: all 0.5s;
    }

    li:hover > a {
      color: $offWhite;
      animation: neon 1.5s ease-in-out infinite alternate;
    }
  }

  &__social {
    display: flex;
    margin-left: auto;
    margin-right: auto;

    a {
      padding: 0 0.7em;
    }
  }
}
</style>
